<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 168 150"
    style="enable-background: new 0 0 168 150"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <g>
          <g class="st3">
            <path
              class="st5"
              d="M37.265,120.783c-0.32,0.32-0.36,0.36-0.72,0.84c-0.96,1.16-2.32,2.6-3.52,3.719
                    c1.959,1.12,3.359,1.76,6.079,2.839c-1,1.36-1.44,2.2-2.08,4c-4.199-1.88-6.359-3.16-9.679-5.799v2.359
                    c-0.8-0.12-1.319-0.16-2.679-0.16h-8.839c-1.04,0-1.8,0.04-2.52,0.16v-2.6c-3.359,2.72-5.56,4.08-9.959,6.199
                    c-0.68-1.72-1.279-2.76-2.159-3.8c2.88-1.12,4.799-2.12,7.519-3.959c-2.079-2.16-3.199-3.12-5.359-4.679l2.96-2.64
                    c2.199,1.68,3.919,3.16,5.599,4.879c1.88-1.64,2.521-2.32,3.8-4.04h-5.279c-0.8,0-1.52,0.04-2.439,0.16v-4.04
                    c1,0.16,1.64,0.2,3.319,0.2h7.519c1.88,0,2.6-0.04,3.439-0.16c0.44,1.64,1,2.6,2.68,4.519c1.479-1.52,2.64-3.04,3.359-4.319
                    l3.319,2.199c-1.039,1.4-2.759,3.28-4.119,4.6c1,0.88,1.479,1.28,2.479,2c1.72-1.6,3.08-3.24,3.96-4.719L37.265,120.783z
                     M12.869,145.499c-0.359-1.04-1.039-2.36-1.64-3.24l3.52-1.28h-4.279c-1.319,0-2.159,0.04-2.879,0.12
                    c0.119-1.08,0.159-1.76,0.159-2.919v-5.039c0-1.04-0.04-1.8-0.159-2.72c1.039,0.12,1.839,0.16,3.159,0.16h18.877
                    c1.399,0,2.159-0.04,3.119-0.16c-0.12,0.88-0.16,1.52-0.16,2.68v5.079c0,1.36,0.04,2,0.16,2.919c-0.76-0.08-1.56-0.12-2.88-0.12
                    h-3.879l3.319,1.2c-0.64,1.2-1.56,2.919-1.84,3.319h6.839c1.88,0,2.76-0.04,3.92-0.2v4.319c-1.2-0.16-2.24-0.2-4.16-0.2H6.39
                    c-1.92,0-2.92,0.04-4.159,0.2v-4.319c1.159,0.16,1.999,0.2,3.879,0.2H12.869z M11.87,137.38h16.477v-3.24H11.87V137.38z
                     M24.706,125.022c0.2,0,0.2,0,1,0c-2.159-1.92-3.52-3.52-5.519-6.279c-1.76,2.56-3.279,4.279-5.52,6.279c0.48,0,0.601,0,1.4,0
                    H24.706z M23.147,145.499c0.88-1.56,1.68-3.28,2.04-4.52h-9.998c0.84,1.56,1.399,2.88,1.999,4.52H23.147z"
            />
            <path
              class="st5"
              d="M49.35,126.861c-0.88,0-1.479,0.04-2.359,0.12v-2.12c-0.761,0.68-1,0.88-1.84,1.56
                    c-0.521-1.64-0.92-2.479-1.84-3.799c3.279-2.279,5.639-5.239,6.919-8.638h4.399c1.359,2.839,2.839,4.559,5.839,6.719
                    c-1.12,1.24-1.68,2.08-2.439,3.56l-0.32-0.28v3c-0.88-0.12-1.24-0.12-2.359-0.12h-1.16v2.68h1.6c1.2,0,2.08-0.04,2.84-0.16
                    v-3.32c1.12,0.16,2.239,0.24,3.839,0.24h10.119c0.079-1.2,0.119-1.6,0.159-2.28h-7.918c-1.8,0-2.64,0.04-3.64,0.16v-3.799
                    c1,0.16,1.76,0.2,3.64,0.2h8.078c0.08-1,0.08-1.12,0.12-2.2h-8.958c-1.68,0-2.84,0.04-3.8,0.16v-3.839
                    c1.12,0.16,2.199,0.2,3.999,0.2h9.398c1.64,0,2.72-0.04,3.68-0.16c-0.12,0.92-0.12,0.92-0.24,3.879
                    c-0.12,2.08-0.319,5.599-0.479,7.679h0.24c1.68,0,2.759-0.08,3.839-0.24v3.959c-1.08-0.12-2.319-0.2-3.799-0.2h-5.359
                    c0.359,2.199,0.76,3.479,1.92,5.919c1.799-1.72,2.799-2.92,3.879-4.799l3.279,2.319c-2,2.44-3.68,4.279-5.319,5.679
                    c1.76,2.479,3.319,3.959,6.159,5.759c-1.08,1.359-1.64,2.279-2.399,3.919c-2.56-2.199-3.6-3.319-4.879-5.159
                    c-1.32-1.88-1.96-3.2-3.04-6.199c0.08,0.8,0.16,2.28,0.24,4.439v5.119c0,2.679-1.16,3.639-4.399,3.639
                    c-0.88,0-1.96-0.04-3.52-0.16c-0.16-1.84-0.359-2.68-0.92-4.04c1.28,0.28,2.4,0.4,3.12,0.4c1.479,0,1.76-0.16,1.76-1.04v-3.799
                    c-1.4,1.16-1.64,1.4-2.84,2.24c-0.68,0.48-0.68,0.48-3.399,2.36c-0.64,0.44-0.64,0.44-1.32,0.919l-1.279-2.839v1.6
                    c-4.079,1.32-7.119,2.12-10.718,2.84c-1.88,0.36-1.92,0.36-3.16,0.72l-0.6-4.399c1.64,0,3.079-0.2,6.239-0.84v-11.198h-2.08
                    c-1.68,0-2.92,0.08-3.919,0.2v-4.079c1.039,0.12,2.279,0.2,3.959,0.2h2.04v-2.68H49.35z M46.23,143.419
                    c-0.319-2.76-0.76-4.759-1.68-7.799l3.12-0.96c0.84,2.56,1.239,4.399,1.76,7.759L46.23,143.419z M49.43,123.262h5.959
                    c0.72,0,0.96,0,1.479-0.04c-1.76-1.76-2.88-3.239-4.239-5.639c-1.2,2.28-2.279,3.839-3.999,5.679H49.43z M62.467,129.821
                    c-1.56,0-2.6,0.04-3.559,0.16v3.439c-0.88-0.16-1.68-0.2-3.12-0.2h-1.6v10.398c1.52-0.36,2.24-0.6,4.359-1.24v0.84
                    c3.199-1.56,5.879-3.319,8.879-5.799v-7.599H62.467z M54.669,140.979c0.84-2.399,1.239-3.999,1.6-6.519l3.039,1
                    c-0.56,2.56-1.04,4.199-1.92,6.399L54.669,140.979z M62.788,130.941c1.88,2.64,2.399,3.479,3.479,5.959l-3.079,2.04
                    c-1.08-2.6-2-4.319-3.52-6.359L62.788,130.941z"
            />
            <path
              class="st5"
              d="M90.19,118.463c0-2.08-0.08-3.359-0.24-4.599h4.6c-0.2,1.28-0.24,2.399-0.24,4.639v5.119h0.88
                    c1.48,0,2.04-0.04,2.68-0.16v4.2c-0.84-0.12-1.56-0.16-2.8-0.16h-0.76v10.878c1.561-0.72,2-0.919,3.8-1.839l0.12,4.239
                    c-3.64,1.959-5.799,2.919-9.879,4.439c-1.119,0.44-1.479,0.6-2.079,0.88l-0.84-4.599c1.199-0.16,2.359-0.52,4.759-1.439v-12.558
                    h-0.92c-1.52,0-2.159,0.04-3.119,0.2v-4.279c0.88,0.16,1.56,0.2,3.119,0.2h0.92V118.463z M104.547,143.939
                    c0,0.8,0.28,1.08,1.16,1.24c1.04,0.2,2.52,0.28,5.439,0.28c4.759,0,6.039-0.2,6.639-1.04c0.479-0.68,0.72-2.04,0.72-4.759
                    c1.279,0.56,2.999,1.08,4.359,1.32c-0.48,7.999-1.32,8.559-12.718,8.559c-8.079,0-9.839-0.76-9.839-4.279v-13.757
                    c-0.359,0.12-0.64,0.2-0.8,0.24c-1.199,0.4-1.64,0.56-2.439,0.92l-1-4.359c1.12-0.16,2.52-0.44,3.88-0.88l0.359-0.12v-5.479
                    c0-1.919-0.04-2.919-0.239-4.239h4.719c-0.16,1.28-0.24,2.439-0.24,4.08v4.359l3.88-1.24v-6.958c0-1.84-0.04-2.68-0.2-4h4.64
                    c-0.16,1.32-0.24,2.6-0.24,4.079v5.599l5.759-1.799c1.56-0.48,2.2-0.72,3.279-1.2c-0.08,1.76-0.12,2.04-0.199,4.2
                    c-0.2,5.639-0.48,9.278-0.88,10.998c-0.521,2.279-1.601,2.959-4.52,2.959c-0.521,0-0.88,0-1.88-0.08
                    c-0.2-1.72-0.479-2.879-1.08-4.119c0.92,0.2,1.64,0.32,2.24,0.32c1,0,1.239-0.16,1.399-1c0.2-1.32,0.36-3.799,0.479-7.679
                    l-4.599,1.44v9.959c0,1.64,0.08,2.759,0.24,3.999h-4.64c0.16-1.36,0.2-2.24,0.2-4.119v-8.479l-3.88,1.24V143.939z"
            />
            <path
              class="st5"
              d="M127.591,148.178c1.359-1.52,1.959-2.279,2.839-3.839c0.88-1.6,1.28-2.479,1.88-4.559l3.959,1.4
                    c-1.279,3.959-2.479,6.319-4.679,9.238L127.591,148.178z M147.707,125.502h7.519c2.24,0,3.52-0.04,4.56-0.2
                    c-0.12,1-0.16,1.96-0.16,3.319v7.439c0,1.36,0.04,2.16,0.16,3.12c-1.12-0.12-2.319-0.16-3.88-0.16h-19.637
                    c-1.56,0-2.759,0.04-3.799,0.16c0.12-1.04,0.16-1.88,0.16-3.04v-7.519c0-1.359-0.04-2.2-0.16-3.319c1.12,0.16,2.56,0.2,4.52,0.2
                    h6.198v-8.079c0-1.56-0.08-2.76-0.279-3.919h5.039c-0.16,1-0.24,2-0.24,3.52v0.64h10.718c1.84,0,3.08-0.08,4.279-0.24v4.399
                    c-1.399-0.16-2.64-0.24-4.279-0.24h-10.718V125.502z M136.99,129.421v5.639h18.276v-5.639H136.99z M139.829,150.378
                    c0.04-0.72,0.04-1.28,0.04-1.64c0-2.28-0.2-4.719-0.6-7.438l3.839-0.6c0.641,3.719,0.92,5.919,1.04,8.958L139.829,150.378z
                     M149.627,150.458c-0.561-2.959-1.48-6.159-2.68-9.119l3.72-1.04c1.479,3.359,2.199,5.439,3.159,8.679L149.627,150.458z
                     M159.866,150.338c-1.64-4.119-2.6-6.039-4.6-9.198l3.76-1.48c1.999,3,2.359,3.6,4.959,8.559L159.866,150.338z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              class="st4"
              d="M84.151,4.233c-16.656,0-30.159,13.503-30.159,30.159c0,6.619,2.138,12.735,5.752,17.708l24.406,38.046
                    l24.406-38.045c3.615-4.973,5.753-11.09,5.753-17.709C114.31,17.736,100.807,4.233,84.151,4.233z M84.151,47.268
                    c-7.111,0-12.876-5.765-12.876-12.876s5.765-12.876,12.876-12.876c7.111,0,12.876,5.765,12.876,12.876
                    S91.262,47.268,84.151,47.268z"
            />
            <path
              class="st5"
              d="M84.151,93.146c-1.021,0-1.974-0.52-2.525-1.38l-24.36-37.974c-4.104-5.679-6.272-12.385-6.272-19.4
                    c0-18.284,14.875-33.159,33.158-33.159c18.284,0,33.159,14.875,33.159,33.159c0,7.016-2.169,13.722-6.274,19.4L86.676,91.766
                    C86.124,92.626,85.172,93.146,84.151,93.146z M84.151,7.233c-14.975,0-27.158,12.184-27.158,27.159
                    c0,5.769,1.791,11.283,5.179,15.945c0.034,0.047,0.067,0.095,0.099,0.144L84.151,84.59l21.881-34.109
                    c0.032-0.049,0.064-0.097,0.099-0.145c3.389-4.661,5.18-10.174,5.18-15.944C111.31,19.417,99.126,7.233,84.151,7.233z
                     M84.151,50.268c-8.754,0-15.876-7.122-15.876-15.875s7.122-15.876,15.876-15.876s15.876,7.122,15.876,15.876
                    S92.905,50.268,84.151,50.268z M84.151,24.516c-5.445,0-9.876,4.43-9.876,9.876c0,5.445,4.431,9.875,9.876,9.875
                    s9.876-4.43,9.876-9.875C94.027,28.946,89.596,24.516,84.151,24.516z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #1e58b5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>